import { useDispatch } from 'react-redux';
import ninjaApi from 'store/redux/apis';
import { logoutAction } from 'store/redux/states/auth.state';
import { removeApiAuthToken } from 'store/redux/utils/authtoken';
import useQueryParams from 'hooks/useQueryParams';

export default function useLogout() {
  const { clearParams } = useQueryParams();

  const dispatch = useDispatch();

  return () => {
    clearParams();
    removeApiAuthToken();
    dispatch(logoutAction());
    dispatch(ninjaApi.util.resetApiState());
  };
}
